import v2ApiClient from './v2ApiClient';

export function getDiscoveryV1(payload = {}, dueTypeFilter) {
  const requestPayload = {
    ...payload,
    ...(dueTypeFilter !== undefined ? { due_type_filter: dueTypeFilter } : {}),
  };
  return v2ApiClient.post('/discovery/dashboard-discovery-v1', requestPayload);
}

export function getDiscoveryOverview(payload = {}, durationFilter) {
  const requestPayload = {
    ...payload,
    ...(durationFilter ? { duration_filter: durationFilter } : {}),
  };
  return v2ApiClient.post('/discovery/dashboard-discovery-overview', requestPayload);
}

export function getRTMData(workspaceId) {
  return v2ApiClient.post('/discovery/dashboard-rtm-data', { workspace_id: Number(workspaceId) });
}

export function getPendingReviewCounts(payload) {
  return v2ApiClient.post('/discovery/dashboard/get-pending-review-counts', payload);
}

export function getQCDashboardStats(payload) {
  return v2ApiClient.post('/discovery/qc-dashboard/aggregate-stats', payload);
}

export function getQCErrorsByProcess(payload) {
  return v2ApiClient.post('/discovery/qc-dashboard/by-process', payload);
}

export function getQCAllErrors(payload) {
  return v2ApiClient.post('/discovery/qc-dashboard/all-errors', payload);
}

export function resolveIEQCError(payload) {
  return v2ApiClient.post('/discovery/ie-qc/resolve-error', payload);
}

export function getWorkspaceMeetingsProcessingStatus(payload) {
  return v2ApiClient.post('/discovery/meetings/workspace-processing-status', payload);
}

export function getFeedEvents(payload) {
  return v2ApiClient.post('/discovery/feed/events', payload);
}

export function getWorkspaceConfig(payload) {
  return v2ApiClient.post('/discovery/workspace/config', payload);
}

const dashboardApi = {
  getDiscoveryV1,
  getDiscoveryOverview,
  getRTMData,
  getPendingReviewCounts,
  getQCDashboardStats,
  getQCErrorsByProcess,
  getQCAllErrors,
  resolveIEQCError,
  getWorkspaceMeetingsProcessingStatus,
  getFeedEvents,
  getWorkspaceConfig,
};

export default dashboardApi;
